import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
import router from './router'
import api from './api'

router.beforeEach(function (to, from, next) {
  api.load(window.localStorage.getItem("language") || 'en', () => {
    next();
  });
});

Vue.config.productionTip = false;
Vue.use(api);
Vue.use(Meta);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
